<template>
  <div>
    <!-- Header -->
    <div class="header bg-gradient-orange py-7 py-lg-8 pt-lg-9">
      <div class="container">
        <div class="header-body text-center mb-7">
          <div class="row justify-content-center">
            <div class="col-xl-5 col-lg-6 col-md-8 px-5">
              <h1 class="text-white">Affiliate Confirmed Successfully!</h1>
              <p class="text-lead text-white">
                Redirect in ... {{ redirectTimes - timer }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="separator separator-bottom separator-skew zindex-100">
        <svg
          x="0"
          y="0"
          viewBox="0 0 2560 100"
          preserveAspectRatio="none"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
        >
          <polygon
            class="fill-default"
            points="2560 0 2560 100 0 100"
          ></polygon>
        </svg>
      </div>
    </div>
    <!-- Page content -->
    <section class="py-6">
      <div class="container mt--9 pb-5">
        <!-- Table -->
        <div class="row justify-content-center">
          <div class="col-lg-6 col-md-8">
            <div class="card bg-secondary border-0">
              <div class="card-body px-lg-5 py-lg-5">
                <p>
                  You will be redirected shortly. If it doesn't happen
                  automatically, please click this link:
                  <router-link to="/dashboard" class="font-weight-bold mt-5"
                    >Back to dashboard.</router-link
                  >
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'success-page',
  data() {
    return {
      redirectTimes: 3,
      timer: 0
    }
  },
  created() {
    //wait component rendered
    setTimeout(() => {
      setInterval(() => {
        this.timer += 1
      }, 1000)
      setTimeout(() => {
        this.$router.push({ name: 'Dashboard' })
      }, this.redirectTimes * 1000)
    }, 1000)
  }
}
</script>
